import { render, staticRenderFns } from "./DetailPeriod.vue?vue&type=template&id=8e7559d8"
import script from "./DetailPeriod.vue?vue&type=script&lang=js"
export * from "./DetailPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports